function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import MenuList from "@material-ui/core/MenuList";
import MenuItem from "@material-ui/core/MenuItem";
import Popper from "@material-ui/core/Popper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import { Link } from "react-router-dom";
import clsx from "clsx";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import withWidth, { isWidthUp } from "@material-ui/core/withWidth";
import Button from "../Button";
import { useToggleMenu } from "./hooks";
const useStyles = makeStyles(({
  transitions,
  palette,
  breakpoints,
  typography
}) => ({
  wrapper: {
    display: "flex",
    justifyContent: "center",
    [breakpoints.down("xs")]: {
      verticalAlign: "bottom"
    },
    [breakpoints.up("sm")]: {
      verticalAlign: "center"
    }
  },
  buttonRoot: {
    fontWeight: 300,
    fontStretch: "normal",
    boxShadow: "none",
    "&:hover": {
      background: "none"
    },
    padding: 0,
    [breakpoints.down("xs")]: {
      fontSize: typography.pxToRem(17),
      lineHeight: 1.66,
      letterSpacing: 0.62
    },
    [breakpoints.up("sm")]: {
      fontSize: typography.pxToRem(22),
      lineHeight: 1.29,
      letterSpacing: 0.8
    }
  },
  expand: {
    fontSize: typography.pxToRem(22),
    lineHeight: 1.3,
    color: palette.text.primary,
    transform: "rotate(0deg)",
    marginLeft: typography.pxToRem(15),
    transition: transitions.create("transform", {
      duration: transitions.duration.shortest
    }),
    "&:hover": {
      background: "none"
    },
    [breakpoints.down("xs")]: {
      marginLeft: typography.pxToRem(5)
    }
  },
  expandOpen: {
    transform: "rotate(180deg)"
  },
  menuPopup: {
    [breakpoints.up("sm")]: {
      width: typography.pxToRem(400)
    },
    [breakpoints.down("xs")]: {
      width: "100%",
      top: `${typography.pxToRem(20)}!important`
    },
    backgroundColor: palette.background.modal
  }
}));

const HeaderMenu = ({
  children,
  actions,
  width,
  pathname,
  isMobileMenuShevronVisible
}) => {
  React.useEffect(() => {
    closeMenu && closeMenu();
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  const theme = useTheme();
  const styles = useStyles();
  const isLargeScreen = isWidthUp("sm", width);
  const {
    open,
    closeMenu,
    anchorRef,
    handleToggle,
    handleClose,
    handleListKeyDown
  } = useToggleMenu();
  return /*#__PURE__*/React.createElement("div", {
    className: styles.wrapper
  }, /*#__PURE__*/React.createElement(Button, {
    ref: anchorRef,
    "aria-controls": "menu-list-grow",
    "aria-haspopup": "true",
    onClick: handleToggle,
    classes: {
      root: styles.buttonRoot
    },
    variant: "text",
    disableRipple: true,
    disableFocusRipple: true
  }, children, (isLargeScreen || isMobileMenuShevronVisible) && /*#__PURE__*/React.createElement(ExpandMoreIcon, {
    className: clsx(styles.expand, {
      [styles.expandOpen]: open
    })
  })), /*#__PURE__*/React.createElement(Popper, {
    open: open,
    anchorEl: anchorRef.current,
    modifiers: {
      computeStyle: {
        enabled: true,
        order: 650,
        fn: data => {
          const styles = { ...data.styles,
            transform: `translate3d(0px, ${theme.typography.pxToRem(46)}, 0px)`
          };
          return { ...data,
            styles
          };
        }
      }
    },
    transition: true,
    disablePortal: true,
    className: styles.menuPopup
  }, ({
    TransitionProps,
    placement
  }) => /*#__PURE__*/React.createElement(Grow, _extends({}, TransitionProps, {
    style: {
      transformOrigin: placement === "bottom" ? "center top" : "bottom"
    }
  }), /*#__PURE__*/React.createElement(Paper, {
    id: "menu-list-grow"
  }, /*#__PURE__*/React.createElement(ClickAwayListener, {
    onClickAway: handleClose
  }, /*#__PURE__*/React.createElement(MenuList, {
    autoFocusItem: open,
    onKeyDown: handleListKeyDown
  }, actions.map(({
    label,
    callback,
    pathname,
    search,
    href,
    ...rest
  }) => {
    const itemProps = { ...rest,
      onClick: () => {
        callback();
        closeMenu();
      }
    };

    if (href) {
      itemProps.component = "a";
      itemProps.href = href;
    } else if (pathname) {
      itemProps.component = Link;
      itemProps.to = `${pathname || ""}${search ? "?" + search : ""}`;
    }

    return /*#__PURE__*/React.createElement(MenuItem, _extends({
      key: label
    }, itemProps), label);
  })))))));
};

export default withWidth()(HeaderMenu);